/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BooleanResponseWrapper,
  DuplicatePageantRequest,
  EventFeeTypeBaseModelIEnumerableResponseWrapper,
  PackageDeleteDependenciesResponseWrapper,
  PageantAgeGroupBaseModel,
  PageantAgeGroupModelIEnumerableResponseWrapper,
  PageantAvailableEventModelIEnumerableResponseWrapper,
  PageantAvailablePackageModelIEnumerableResponseWrapper,
  PageantAvailableTitleModelIEnumerableResponseWrapper,
  PageantAwardTypeWinnersDto,
  PageantModel,
  PageantModelResponseWrapper,
  ProblemDetails,
  UserBaseModel,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Pageant<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Pageant
   * @name GetPageantById
   * @request GET:/Pageant/GetPageantById:{pageantId}
   */
  getPageantById = (pageantId: number, params: RequestParams = {}) =>
    this.request<PageantModelResponseWrapper, any>({
      path: `/Pageant/GetPageantById:${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name GetPageantByIdNew
   * @request GET:/Pageant/GetPageantByIdNew/{pageantId}
   */
  getPageantByIdNew = (pageantId: number, params: RequestParams = {}) =>
    this.request<PageantModelResponseWrapper, any>({
      path: `/Pageant/GetPageantByIdNew/${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name PublicDetailsDetail
   * @request GET:/Pageant/{pageantId}/public-details
   */
  publicDetailsDetail = (
    pageantId: number,
    query?: {
      /** @format int32 */
      currentUserId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantModel, ProblemDetails>({
      path: `/Pageant/${pageantId}/public-details`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name SharePageant
   * @request GET:/Pageant/Share/{pageantId}
   */
  sharePageant = (
    pageantId: number,
    query?: {
      /** @format int32 */
      currentUserId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/Pageant/Share/${pageantId}`,
      method: 'GET',
      query: query,
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name BeginScoringProcess
   * @request POST:/Pageant/BeginScoringProcess/BeginScoringProcess:{pageantId}
   */
  beginScoringProcess = (pageantId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Pageant/BeginScoringProcess/BeginScoringProcess:${pageantId}`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name AddPageant
   * @request POST:/Pageant
   */
  addPageant = (data: PageantModel, params: RequestParams = {}) =>
    this.request<PageantModelResponseWrapper, any>({
      path: `/Pageant`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name PatchPageant
   * @request PATCH:/Pageant
   */
  patchPageant = (data: PageantModel, params: RequestParams = {}) =>
    this.request<PageantModelResponseWrapper, any>({
      path: `/Pageant`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name DeletePageant
   * @request DELETE:/Pageant/{pageantId}
   */
  deletePageant = (pageantId: number, params: RequestParams = {}) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/Pageant/${pageantId}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name GetPackageDeleteDependencies
   * @request GET:/Pageant/Package-Delete-Dependencies
   */
  getPackageDeleteDependencies = (
    query?: {
      /** @format int32 */
      packageId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<PackageDeleteDependenciesResponseWrapper, any>({
      path: `/Pageant/Package-Delete-Dependencies`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name GetAllEventFeeTypes
   * @request GET:/Pageant/EventFeeType
   */
  getAllEventFeeTypes = (params: RequestParams = {}) =>
    this.request<EventFeeTypeBaseModelIEnumerableResponseWrapper, any>({
      path: `/Pageant/EventFeeType`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name SaveAgeGroupsCreate
   * @request POST:/Pageant/{pageantId}/save-age-groups
   */
  saveAgeGroupsCreate = (pageantId: number, data: PageantAgeGroupBaseModel[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Pageant/${pageantId}/save-age-groups`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name DeleteAgeGroupsCreate
   * @request POST:/Pageant/{pageantId}/delete-age-groups
   */
  deleteAgeGroupsCreate = (pageantId: number, data: number[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/Pageant/${pageantId}/delete-age-groups`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name DuplicateAgeDivisions
   * @request POST:/Pageant/Duplicate-Age-Divisions
   */
  duplicateAgeDivisions = (
    query?: {
      /** @format int32 */
      existingPageantId?: number;
      /** @format int32 */
      newPageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantAgeGroupModelIEnumerableResponseWrapper, any>({
      path: `/Pageant/Duplicate-Age-Divisions`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name DuplicateAgeGroupsAndDivisions
   * @request POST:/Pageant/Duplicate-Age-Groups-And-Divisions
   */
  duplicateAgeGroupsAndDivisions = (
    query?: {
      /** @format int32 */
      existingPageantId?: number;
      /** @format int32 */
      newPageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantAgeGroupModelIEnumerableResponseWrapper, any>({
      path: `/Pageant/Duplicate-Age-Groups-And-Divisions`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name DuplicatePageantPackages
   * @request POST:/Pageant/Duplicate-Pageant-Packages
   */
  duplicatePageantPackages = (
    query?: {
      /** @format int32 */
      existingPageantId?: number;
      /** @format int32 */
      newPageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantAvailablePackageModelIEnumerableResponseWrapper, any>({
      path: `/Pageant/Duplicate-Pageant-Packages`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name DuplicatePageantAwards
   * @request POST:/Pageant/Duplicate-Pageant-Awards
   */
  duplicatePageantAwards = (
    query?: {
      /** @format int32 */
      existingPageantId?: number;
      /** @format int32 */
      newPageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantAvailableTitleModelIEnumerableResponseWrapper, any>({
      path: `/Pageant/Duplicate-Pageant-Awards`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name DuplicatePageantAoc
   * @request POST:/Pageant/Duplicate-Pageant-AOC
   */
  duplicatePageantAoc = (
    query?: {
      /** @format int32 */
      existingPageantId?: number;
      /** @format int32 */
      newPageantId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantAvailableEventModelIEnumerableResponseWrapper, any>({
      path: `/Pageant/Duplicate-Pageant-AOC`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name DuplicatePageant
   * @request POST:/Pageant/Duplicate
   */
  duplicatePageant = (data: DuplicatePageantRequest, params: RequestParams = {}) =>
    this.request<PageantModelResponseWrapper, any>({
      path: `/Pageant/Duplicate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name ResultsDetail
   * @request GET:/Pageant/{pageantId}/results
   */
  resultsDetail = (pageantId: number, params: RequestParams = {}) =>
    this.request<PageantAwardTypeWinnersDto[], any>({
      path: `/Pageant/${pageantId}/results`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Pageant
   * @name TestAutoMapper
   * @request GET:/Pageant/TestAutoMapper
   */
  testAutoMapper = (params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/Pageant/TestAutoMapper`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags User
   * @name GetUsersByPageant
   * @request GET:/Pageant/{pageantId}/GetUsersByPageant:Users
   */
  getUsersByPageant = (pageantId: number, users: string, params: RequestParams = {}) =>
    this.request<UserBaseModel[], any>({
      path: `/Pageant/${pageantId}/GetUsersByPageant${users}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
